// 编辑弹窗混入，
import { copyObject } from '@/common/utils';
export default {
    props: {
        // 弹窗是否显示
        dialogShow: {
            type: Boolean,
            default: false
        },
        // 父组件传入数据
        formData: {
            type: Object,
            default() {
                return null;
            }
        }
    },
    data() {
        return {
            refName: "formEdit", // 根据不同弹窗修改
            formEdit: null // 编辑数据
        }
    },
    computed: {
        // 是否处于编辑状态
        isEdit() {
            return !!this.formData;
        }
    },
    methods: {
        // 关闭弹窗
        handleClose() {
            this.$emit('update:dialogShow', false);
        },
        // 清除校验
        clearField(item) {
            this.$nextTick(() => {
                if (this.$refs[this.refName]) {
                    this.$refs[this.refName].clearValidate(item);
                }
            })
        },
        // 部分表单校验
        validateField(name) {
            this.$nextTick(() => {
                if (this.$refs[this.refName]) {
                    this.$refs[this.refName].validateField(name);
                }
            })
        }
    },
    created() {
        // 复制重置数据的格式
        this.formEdit = JSON.parse(JSON.stringify(this.formReset));
    },
    watch: {
        // 监听弹窗显示关闭时，清空或复制相关数据
        dialogShow: {
            handler(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.$refs[this.refName].resetFields();
                        if (!this.formData) {
                            this.formEdit = JSON.parse(JSON.stringify(this.formReset));
                        } else {
                            this.formEdit = copyObject(this.formReset, this.formData);
                        }
                    })
                }
            },
            immediate: true
        }
    }
}